import React from "react"
import styled from "styled-components"
import { Button, Typography } from "antd"

const { Title } = Typography

const BannerContainer = styled.div`
    padding: 100px 20px;
    max-height: 400px;
    background-color: #3a40c4;
    display: flex;
    justify-content: center;
    align-items: center;
`

const StyledTitle: typeof Title = styled(Title)`
    text-align: center;
    color: white !important;

    @media (max-width: 768px) {
        font-size: 25px !important;
    }
`

const StyledButton: typeof Button = styled(Button)`
    // font-weight: bold;
    padding: 0.1px 20px !important;
`

const Banner: React.FC = () => {
    return (
        <BannerContainer className={"mt-20"}>
            <div>
                <StyledTitle>
                    Heard enough? Let's get you your workers under 24 hours
                </StyledTitle>
                <p style={{ textAlign: "center" }}>
                    <StyledButton
                        type="primary"
                        size="large"
                        shape="round"
                        href="/login"
                    >
                        Hire Great Staff Now
                    </StyledButton>
                </p>
            </div>
        </BannerContainer>
    )
}

export default Banner
